import { ShieldX } from 'lucide-react';
import { Link } from 'react-router';
import { BrandLogo } from '@/components/brand/BrandLogo';
import { PageContainer } from '@/components/layout/PageHeader';
import { EmptyState, ErrorState } from '@/components/states/States';
import { Button } from '@/components/ui/button';

/** Rota existente, mas fora dos módulos do perfil do usuário. */
export function ForbiddenPage({ homePath }: { homePath: string | null }) {
  return (
    <PageContainer>
      <EmptyState
        icon={ShieldX}
        title="Seu perfil não tem acesso a esta tela"
        description="Se você precisa dela no seu trabalho, peça ao administrador da sua empresa para ajustar seu perfil."
        action={
          homePath ? (
            <Button asChild variant="outline">
              <Link to={homePath}>Ir para o início</Link>
            </Button>
          ) : null
        }
      />
    </PageContainer>
  );
}

/** Restaurando a sessão ao abrir o app. */
export function SessionLoadingPage() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-background"
    >
      <BrandLogo className="motion-safe:animate-pulse" />
      <span className="text-sm text-muted-foreground">Carregando sua sessão…</span>
    </div>
  );
}

/** Não foi possível falar com a API para restaurar a sessão (sem rede, servidor fora). */
export function SessionErrorPage({ error, onRetry }: { error: unknown; onRetry: () => void }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-2 bg-background px-4">
      <BrandLogo />
      <ErrorState error={error} title="Não foi possível abrir sua sessão" onRetry={onRetry} />
    </div>
  );
}
